import React from 'react';

import Button from '@atlaskit/button';

import { QALITY_TEST_ISSUE_TYPE } from '@qality/common-config/src/constants';
import { messages } from '@qality/common-messages';
import {
  IssueService,
  ProjectService,
  StorageOfUniqueServices,
} from '@qality/common-service';

import { CenteredDivStyled } from './Welcome.styled';
import './_welcome.scss';

const Welcome = (): JSX.Element => {
  const ICON_PATH =
    StorageOfUniqueServices.get('URLService').getQAlityIssueIcon();

  const goToConfiguration = async () => {
    try {
      const issueKey = await StorageOfUniqueServices.get(
        'ContextParamsService'
      ).getIssueKey();
      const issue = await IssueService.getIssue(issueKey);
      const project = await ProjectService.getProject(issue.fields.project.key);
      window.open(
        StorageOfUniqueServices.get('URLService').getProjectConfigIssueTypesUrl(
          project
        ),
        '_blank'
      );
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleCriticalError(
        e,
        messages['error.welcome.goToConfiguration.message'],
        plugin.servicedeskUrl
      );
    }
  };

  return (
    <div>
      <CenteredDivStyled>
        <h2 className='welcome-title'>Welcome to {plugin.name}</h2>
      </CenteredDivStyled>
      <CenteredDivStyled>
        To start using {plugin.name}, a Project Administrator needs to add a new
        issue type to the project configuration.
      </CenteredDivStyled>
      <div className='welcome-issue-types'>
        <div className='welcome-issue-types-info'>
          <CenteredDivStyled>
            We detected that you don&apos;t have issue type needed to use this
            app.
          </CenteredDivStyled>
          <CenteredDivStyled>
            Add it in issue types settings for this project and then refresh
            page.
          </CenteredDivStyled>
        </div>
        <CenteredDivStyled>
          <div className='welcome-issue-types-container-icon'>
            <img
              src={ICON_PATH}
              alt='Icon'
              className='welcome-issue-types-icon'
            />
            {QALITY_TEST_ISSUE_TYPE}
          </div>
        </CenteredDivStyled>
      </div>
      <CenteredDivStyled className='welcome-button-wrapper'>
        <Button onClick={goToConfiguration} appearance='primary'>
          Go to configuration
        </Button>
      </CenteredDivStyled>
    </div>
  );
};

export default Welcome;
